/**
 * Colored brand marks for marketing / Integrations page (Simple Icons CDN).
 * slug + hex (no #) — https://github.com/simple-icons/simple-icons
 */
const SLUG_HEX = {
  github: ["github", "181717"],
  slack: ["slack", "4A154B"],
  "google-drive": ["googledrive", "4285F4"],
  figma: ["figma", "F24E1E"],
  notion: ["notion", "000000"],
  jira: ["jira", "0052CC"],
  vscode: ["visualstudiocode", "007ACC"],
  discord: ["discord", "5865F2"],
};

export function getIntegrationBrandLogoUrl(integrationId) {
  const pair = SLUG_HEX[integrationId];
  if (!pair) return null;
  return `https://cdn.simpleicons.org/${pair[0]}/${pair[1]}`;
}
